module.exports = __webpack_public_path__ + "assets/05cb8ff22c2b242124a9e2e5c5f3050d.mp3";